import React from "react";
import Orders from "../components/orderList/Orders";
import TitleUpdater from "../components/common/layout/TitleUpdater";

export default function OrdersPage() {

  return (
    <div>
      <TitleUpdater />
      <Orders />
    </div>
  );
}
